import { render, staticRenderFns } from "./ma.vue?vue&type=template&id=3f0c73be&scoped=true&lang=pug&"
import script from "./ma.vue?vue&type=script&lang=js&"
export * from "./ma.vue?vue&type=script&lang=js&"
import style0 from "./ma.vue?vue&type=style&index=0&id=3f0c73be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0c73be",
  null
  
)

export default component.exports